// config.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  apiUrl = '/api'; // La ruta base para las solicitudes a la API
}